import axios from "axios";
import { config_headers, URL_API, servicelist } from "../Config";

export const P213GetColumnList = async (body) => {
    return new Promise(async (resolve, reject) => {
        try {
            let authorization = await config_headers();
            // console.log('authorization ',authorization.headers);
            await axios
                .post(URL_API(`${servicelist.SupervisorService}p_supervisor_boq_head_info`), body, authorization)
                .then((res) => {
                    resolve(res.data);
                })
                .catch((error) => {
                    reject(error);
                });
        } catch (err) {
            reject(err);
        } finally {
        }
    });
};

export const P213GetDataList = async (body) => {
    return new Promise(async (resolve, reject) => {
        try {
            let authorization = await config_headers();
            // console.log('authorization ',authorization.headers);
            await axios
                .post(URL_API(`${servicelist.SupervisorService}p_supervisor_memo_sheet_detail_info`), body, authorization)
                .then((res) => {
                    resolve(res.data);
                })
                .catch((error) => {
                    reject(error);
                });
        } catch (err) {
            reject(err);
        } finally {
        }
    });
};

export const P213UpdateData = async (body) => {
    return new Promise(async (resolve, reject) => {
        try {
            let authorization = await config_headers();
            // console.log('authorization ',authorization.headers);
            await axios
                .post(URL_API(`${servicelist.SupervisorService}p_supervisor_memo_sheet_detail_update`), body, authorization)
                .then((res) => {
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        } catch (err) {
            reject(err);
        } finally {
        }
    });
};

// export const P213UpdateDetailData = async (body) => {
//     return new Promise(async (resolve, reject) => {
//         try {
//             let authorization = await config_headers();
//             // console.log('authorization ',authorization.headers);
//             await axios.post(URL_API(`${servicelist.P1Service}p_p1_detail_update`), body, authorization).then((res) => {
//                 resolve(res);
//             });
//         } catch (err) {
//             reject(err);
//         } finally {
//         }
//     });
// };

export const P213UpdateDetailData = async (body) => {
    return new Promise(async (resolve, reject) => {
        try {
            let authorization = await config_headers();
            // console.log('authorization ',authorization.headers);
            await axios.post(URL_API(`${servicelist.P1Service}p_supervisor_memo_sheet_detail_update`), body, authorization).then((res) => {
                resolve(res);
            });
        } catch (err) {
            reject(err);
        } finally {
        }
    });
};
